import React from 'react';
import {HtmlParse} from 'utils';
import PropTypes from 'prop-types';
import calendar from 'images/icons/calendar.svg';
import { modalReschedule } from 'config/translate/variables';
import { withRouter } from "react-router";
import style from './style.scss';//NOSONAR

const RescheduleMessage = (props) => {
    const openOrder = () => {
        //CAMBIAR LOGICA CUANDO ESTE EL SERVICIO
        const order = 'v15511126jmch-01'

        props.history.push(`/mis-compras/${order}`);
        props.closeRescheduleMessage();
    }

    return (
        <div className={'modal-reschedule-alert-wrap'}>
            <div className={'modal-reschedule-body'}>
                <div className={'reschedule-image'}>{HtmlParse(calendar)}</div>
                <p>Debido a la alta demanda, la preparación de tu pedido está retrasada. <strong>Por favor selecciona una nueva fecha </strong>para reprogramar su entrega.</p>
            </div>
            <div className="modal-actions">
                <button type="button" className={'secundary-btn'} onClick={()=>props.closeRescheduleMessage()}>
                    <span className="register-btn-back">{modalReschedule.btnCancel}</span>
                </button>
                <button type="submit" className={'primary-btn'} onClick={() => openOrder()}>
                    <span className="btn-submit-next">{modalReschedule.btnSubmit}</span>
                </button>
            </div>
        </div>
    );
}

RescheduleMessage.propTypes = {
    history: PropTypes.object,
    closeRescheduleMessage: PropTypes.func
};

export default withRouter(RescheduleMessage);
